/**
 * @overview Global sizing helpers
 */

/* eslint-disable no-inline-comments */
/* eslint-disable no-multi-spaces */

// Margin && Padding Sizes
const sizes = [
  `0.125rem`, // spacingsize(1) | 2px
  `0.25rem`,  // spacingsize(2) | 4px
  `0.5rem`,   // spacingsize(3) | 8px
  `0.75rem`,  // spacingsize(4) | 12px
  `1rem`,     // spacingsize(5) | 16px
  `1.25rem`,  // spacingsize(6) | 20px
  `1.5rem`,   // spacingsize(7) | 24px
  `1.75rem`,  // spacingsize(8) | 28px
  `2rem`,     // spacingsize(9) | 32px
  `2.5rem`,   // spacingsize(10) | 40px
  `3rem`,     // spacingsize(11) | 48px
  `4rem`,     // spacingsize(12) | 64px
  `5rem`,     // spacingsize(13) | 80px
];

// Font Sizes
const fonts = [
  `0.75rem`,  // fontsize(1) | 12px
  `0.875rem`, // fontsize(2) | 14px
  `1rem`,     // fontsize(3) | 16px
  `1.125rem`, // fontsize(4) | 18px
  `1.25rem`,  // fontsize(5) | 20px
  `1.5rem`,   // fontsize(6) | 24px
  `2rem`,     // fontsize(7) | 32px
  `2.25rem`,  // fontsize(8) | 36px
  `3.125rem`, // fontsize(9) | 50px
  `3.75rem`,  // fontsize(10)| 60px
  `5rem`,     // fontsize(11)| 80px
];

// Radius Sizes
// Border radius sizes
const radii = [
  `0.3125rem`,  // radiussize(1) | 5px
];

export const spacingsize = (num) => {
  return sizes[num - 1];
};

export const fontsize = (num) => {
  return fonts[num - 1];
};

export const radiussize = (num) => {
  return radii[num - 1];
};
